import { CourseDef } from '../../../../types';
import L2926568 from './2926568';
import L2926569 from './2926569';
import L4313010 from './4313010';
// import L5232911 from './5232911';
import L5232912 from './5232912';

export const realityTrader: CourseDef = {
  courseTitle: 'REALITY TRADER DO ZERO A DUBAI',
  lessons: [L2926568, L2926569, L4313010, 
    // L5232911, 
    L5232912],
};

